import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerUiSettingsPage from "../pages/DsokCustomerUiSettingsPage";

export const dsokCustomerUiSettingsRoute = {
  path: "/dsok/customer-detail/:customerUrl/ui-settings",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerUiSettingsPage} />
    </DsokCustomerDetailProvider>
  ),
};
